export default {"id":"9840cc3e","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}